window.addEventListener("DOMContentLoaded", () => {
	document.querySelectorAll(".ty-nav-links > a").forEach(item => {
		item.addEventListener("click", () => {
			item.parentNode.parentNode
				.querySelectorAll(".active")
				.forEach(notcurrent => {
					notcurrent.classList.remove("active");
				});
			item.parentNode.classList.toggle("active");
		});
	});

	document.querySelectorAll("*[data-heading]").forEach(heading => {
		heading.addEventListener("mouseenter", () => {
			document
				.querySelector('a[data-menu="#' + heading.dataset.heading + '"]')
				.classList.add("hover");
		});

		heading.addEventListener("mouseleave", () => {
			document
				.querySelector('a[data-menu="#' + heading.dataset.heading + '"]')
				.classList.remove("hover");
		});
	});
});

window.addEventListener("resize", function() {
	if (window.innerWidth >= 1024) {
		sideBarPosition();
	}
});

window.addEventListener("scroll", function() {
	document.querySelectorAll("*[data-heading]").forEach(heading => {
		highlightMenu(heading);
	});

	sideBarPosition();
});

function highlightMenu(element) {
	const progressbar = document.querySelector(".ty-progressbar");
	const list = document.querySelector(".ty-nav-links");
	const distanceToTop = getDistanceToTop(element);
	const hitTop = distanceToTop - 114 - window.scrollY;
	const heading = document.querySelector(
		'a[data-menu="#' + element.dataset.heading + '"]'
	);

	if (hitTop <= 0) {
		heading.classList.add("last");
		if (
			heading.previousElementSibling &&
			heading.previousElementSibling.classList.contains("last")
		) {
			heading.previousElementSibling.classList.remove("last");
		}
		progressbar.style.height =
			list.clientHeight -
			(list.getBoundingClientRect().bottom -
				document.querySelector("a.last").getBoundingClientRect().bottom) +
			"px";
	} else {
		if (document.querySelector("a.last") !== null) {
			progressbar.style.height =
				list.clientHeight -
				(list.getBoundingClientRect().bottom -
					document.querySelector("a.last").getBoundingClientRect().bottom) +
				"px";
			heading.classList.remove("last");
		} else {
			progressbar.style.height = "0";
		}
	}
}

function sideBarPosition() {
	const sidebar = document.querySelector(".ty-sidebar");
	if (!sidebar) {
		return;
	}
	const vacancySidebar = document.querySelector(".ty-nav");
	const distanceToTop = getDistanceToTop(vacancySidebar);
	const bottomOfVacancyBar = vacancySidebar.getBoundingClientRect().bottom;
	const leftOfVacancyBar = vacancySidebar.getBoundingClientRect().left;
	const bottomOfSidebar = sidebar.getBoundingClientRect().bottom;
	const topOfSidebar = sidebar.getBoundingClientRect().top;
	const hitTop = distanceToTop - 112 - window.scrollY;

	if (hitTop <= 0) {
		sidebar.classList.add("scroll-along");
		sidebar.style.left = leftOfVacancyBar + "px";

		if (topOfSidebar >= 112 && bottomOfVacancyBar > bottomOfSidebar) {
			sidebar.classList.remove("stay-here");
			sidebar.style.left = leftOfVacancyBar + "px";
		} else if (topOfSidebar <= 112 && bottomOfVacancyBar <= bottomOfSidebar) {
			sidebar.classList.remove("scroll-along");
			sidebar.classList.add("stay-here");
			sidebar.style.left = "0";
		} else {
			sidebar.classList.remove("stay-here");
			sidebar.style.left = leftOfVacancyBar + "px";
		}
	} else {
		sidebar.classList.remove("scroll-along");
		sidebar.style.left = "auto";
	}
}

function getDistanceToTop(element) {
	const rect = element.getBoundingClientRect();
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	return rect.top + scrollTop;
}



// WEBPACK FOOTER //
// ./scripts/modules/sidebar.js